import React, { useCallback, useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/react-hooks';
import { getPrices } from '../../../utils/accommodations-and-activities/prepareReceivedActivityData';
import moment from 'moment';
import { WIDGET_ACTIVITIES } from '../../../graphql/queries/activities';

export const useActivitiesInfiniteQuery = ({ startDate, endDate, guests, ownerId }, skip) => {
  const [page, setPage] = useState(0);
  const [activities, setActivities] = useState(null);
  const [fetchMore, { loading, data, networkStatus }] = useLazyQuery(WIDGET_ACTIVITIES, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    onCompleted: (accData) => {
      if (!accData || !accData.activities) return;


      const newActivities = accData.activities.map(item => {
        if (item.location) {
          return item;
        }

        return {
          ...item,
          location: item.startingPoint,
          guestsNumber: item.maxParticipants,
          bedDetails: [],
          ...getPrices(item)
        };
      });

      if (activities?.length) {
        setPage(page + 1);
      }

      setActivities([...(activities || []), ...newActivities]);
    }
  });

  const fetchData = useCallback((requestedPage) => {
    const variables = {
      page: requestedPage ?? 0,
      businessOwnerId: ownerId,
      numberOfActivityPerPage: 9,
      startPeriod: startDate && moment(startDate).format('YYYY-MM-DD'),
      endPeriod: endDate && moment(endDate).format('YYYY-MM-DD')
    };

    if (guests) {
      variables.guestsNumber = guests;
    }

    fetchMore({ variables });
  }, [guests, ownerId, startDate, endDate]);

  useEffect(() => {
    if (!skip) {
      fetchData(0);
    }
  }, []);

  useEffect(() => {
    if (!startDate || !endDate) return;
    setActivities([]);
    fetchData(0);
    setPage(0);
  }, [startDate, endDate]);

  useEffect(() => {
    if (guests && startDate && endDate) {
      setActivities([]);
      fetchData(0);
      setPage(0);
    }
  }, [guests]);

  return {
    activitiesPage: page,
    activities,
    fetchActivitiesData: fetchData,
    loading,
    perPage: data ? data.numberOfActivitiesPages - 1 : 0
  }
}
